import styled from "styled-components";
import media from "constants/media";

export const QuantityStyled = styled.div`
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    min-height: 95px;
    margin-bottom: 20px;
    margin-left: auto;

    background-color: var(--color-white);

    border: 1px solid var(--color-lightGrey);

    ${media.smUp`
        margin: 0 20px 0 0;
    `}

    ${media.mdUp`
        max-width: 220px;
    `}
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    text-align: center;

    ${media.smUp`
        flex-direction: column;
    `}
`;

export const Text = styled.span`
    display: block;
    width: 100%;

    font-weight: 500;

    ${media.smUp`
        padding-bottom: 20px;
        align-items: center;
    `}
`;
